export default __webpack_public_path__ + "static/media/congrat.57d5e0f5.svg";